import Filter from '@app/shared/filters/filter.model';

export class FilterType {
  /** Filter for key: App */
  public static App                  = new Filter('App');
  /** Filter for key: Course */
  public static Course               = new Filter('Course');
  /** Filter for key: Guide */
  public static GuidesPerLevel       = new Filter('Guide');
  /** Filter for key: Level */
  public static Level                = new Filter('Level');
  /** Filter for key: Map */
  public static MapPercentage        = new Filter('Map');
  /** Filter for key: NonIntegratedApp */
  public static NonIntegratedApp     = new Filter('NonIntegratedApp');
  /** Filter for key: NonIntegratedCourse */
  public static NonIntegrationCourse = new Filter('NonIntegratedCourse');
  /** Filter for key: NonMapSubject */
  public static NonMapSubject        = new Filter('NonMapSubject');
  /** Filter for key: Season */
  public static Season               = new Filter('Season');
  /** Filter for key: Session */
  public static Session              = new Filter('Session');
  /** Filter for key: Student */
  public static Student              = new Filter('Student');
  /** Filter for key: Grade */
  public static StudentGradeLevel    = new Filter('Grade');
  /** Filter for key: Subject */
  public static Subject              = new Filter('Subject');
  /** Filter for key: Week */
  public static Week                 = new Filter('Week');
  /** Filter for key: AlphaYears */
  public static YearAtAlpha          = new Filter('AlphaYears');
  /** Filter for key: Score */
  public static Score                 = new Filter('Score');
}
